import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';

@Component({
	template:'<div class="text" padding [innerHtml]="text | translate"></div><div *ngIf="isDoc" padding-left padding-right padding-bottom><img  src="assets/imgs/document-new.png"></div>'
})
export class PopoverInfo {
    text: string = '';
    isDoc: boolean;

    constructor(
        public viewCtrl: ViewController) {
        this.text = viewCtrl.data.infoData;
		this.isDoc = viewCtrl.data.isDoc;
		console.log('this.isDoc', this.isDoc);
    }

    close() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/components/teaser/teaser.popover.ts